(() => {
  const initialize = root => {
    root.querySelectorAll('[data-rs-gallery]').forEach(gallery => {
      if (gallery.dataset.rsReady) return;
      gallery.dataset.rsReady = 'true';
      const thumbs = [...gallery.querySelectorAll('[data-rs-thumb]')];
      const main = gallery.querySelector('[data-rs-gallery-main]');
      const caption = gallery.querySelector('[data-rs-gallery-caption]');
      let index = 0;
      const show = (next, focus = false) => {
        index = (next + thumbs.length) % thumbs.length;
        const selected = thumbs[index];
        main.src = selected.dataset.rsSrc;
        main.alt = selected.dataset.rsAlt;
        caption.textContent = selected.dataset.rsAlt;
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-pressed', String(i === index));
        });
        if (focus) selected.focus({ preventScroll: true });
      };
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => show(i));
        thumb.addEventListener('keydown', event => {
          const next = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? index + 1 : event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? index - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : null;
          if (next !== null) { event.preventDefault(); show(next, true); }
        });
      });
      gallery.querySelector('[data-rs-prev]')?.addEventListener('click', () => show(index - 1));
      gallery.querySelector('[data-rs-next]')?.addEventListener('click', () => show(index + 1));
    });
    root.querySelectorAll('[data-rs-series]').forEach(series => {
      if (series.dataset.rsReady) return;
      series.dataset.rsReady = 'true';
      const filters = [...series.querySelectorAll('[data-rs-filter]')];
      const cards = [...series.querySelectorAll('[data-rs-card]')];
      const groups = { compact: ['400', '600'], tall: ['1000', '1500', '3000'], wide: ['5000', '6000'] };
      const labels = { all: 'Showing all seven panels.', compact: 'Showing two compact formats. Compare dimensions to plan your space.', tall: 'Showing three taller formats. Check the setup and included hardware.', wide: 'Showing two larger formats. Check panel width, height and mounting needs.' };
      filters.forEach(button => button.addEventListener('click', () => {
        const group = button.dataset.rsFilter;
        filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        cards.forEach(card => { card.hidden = group !== 'all' && !groups[group].includes(card.dataset.rsCard); });
        series.querySelector('[data-rs-filter-status]').textContent = labels[group];
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
